import React from 'react'
import * as Accessa from 'accessa'
import {
  Box,
  Container,
  Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Breadcrumbs from './Breadcrumbs'

const useStyle = makeStyles((theme) => ({
  header: {
    marginBottom: '1rem',
    marginTop: 0,
  },
  root: {
    minHeight: 'calc(100vh - 150px)',
    [theme.breakpoints.down('md')]: {
      minHeight: 'auto',
    },
  },
}))

// eslint-disable-next-line
const ArchiveLayout = ({ children, title, ...rest }) => {
  const cls = useStyle()
  return (
    <Box
      bgcolor="secondary.main"
      color="primary.contrastText"
      component="article"
      pt="150px"
    >
      <Accessa.Layouts.Neapolitan {...rest}>
        <Box position="relative" mx={-1}>
          <Box py={4} className={cls.root}>
            <Container maxWidth="md">
              <Typography
                variant="h1"
                color="inherit"
                className={cls.header}
              >
                {title}
              </Typography>
              <Box mt={0.5} mb={4}>
                <Breadcrumbs title={title} />
              </Box>
              {children}
            </Container>
          </Box>
        </Box>
      </Accessa.Layouts.Neapolitan>
    </Box>
  )
}
export default ArchiveLayout
